const strategiesList = ['Hodor', 'SuperAdmin', 'GroupAdmin', 'ProviderAdmin', 'ServiceAdmin', 'Parent', 'Educator', 'Xplorer']

const strategyToUserType = {
  'SuperAdmin': 'Username',
  'GroupAdmin': 'Username',
  'ProviderAdmin': 'Username',
  'ServiceAdmin': 'Username',
  'Parent': 'Email address',
  'Educator': 'Email address',
  'Xplorer': 'Email address'
}

const uniqueArray = (array) => {
  return array.filter(function (elem, pos, arr) {
    return arr.indexOf(elem) === pos
  })
}

const validStrategy = (strategy) => {
  return strategiesList.indexOf(strategy) !== -1
}

const parseStrategyParams = (strategiesParam) => {
  if (!strategiesParam) return strategiesList
  
  const strategies = strategiesParam.split(',').map(str => str.trim())
  
  strategies.forEach(strategy => {
    if(!validStrategy(strategy)) {
      throw new Error('Invalid strategy')
    }
  })

  return strategies
}

const strategiesToUserType = (strategies) => {
  if (strategies.indexOf('Hodor') !== -1) {
    return 'Username or Email address'
  }
  
  return uniqueArray(strategies.map((strategy) => {
    return strategyToUserType[strategy]
  })).join(' or ')
}

export default {
  strategiesToUserType,
  parseStrategyParams,
  strategiesList
}


// WEBPACK FOOTER //
// ./src/utils/strategyUtils.js